import React from "react";
import DialogHeader from "./footer/DialogHeader";

interface GxSmallDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  width?: string;
  maxHeight?: string;
  showCloseButton?: boolean;
  showAppLogo?: boolean;
  className?: string;
}

export const GxSmallDialog: React.FC<GxSmallDialogProps> = ({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  width = "",
  maxHeight = "",
  showCloseButton = true,
  showAppLogo = false,
  className = "",
}) => {
  if (!isOpen) return null;

  return (
    <div className="gx-form-dialog-layout">
      <div className={`gx-form-dialog-box `}>
        {/* Header */}
        {(title || showCloseButton || showAppLogo) && (
          <div className="gx-form-dialog-header">
            <DialogHeader
              handleClose={onClose}
              title={title}
              subtitle={subtitle}
              showAppLogo={showAppLogo}
            />
          </div>
        )}

        {/* Content */}
        <div className={`${maxHeight} gx-form-dialog-content`}>{children}</div>
      </div>
    </div>
  );
};

export default GxSmallDialog;
